/* eslint-disable @typescript-eslint/naming-convention -- Mui */
import { Stack, Typography } from "@mui/material";
import { useEffect, useState, type FC } from "react";
import { useRequest } from "../../contexts/RequestProvider";
import { useForm } from "../../helpers/forms/FormProvider";
import { FormTextField } from "../form-components/form-text-field/FormTextField";
import { GenericCheckbox } from "../three-checkbox/GenericCheckbox";
import type { Opportunity } from "@entities";

type Options = "custom" | "all" | "18";

function optionFromAges(minAge?: number, maxAge?: number): Options {
  if (minAge === 18 && maxAge === 120) return "18";
  if (minAge === 6 && maxAge === 120) return "all";
  return "custom";
}

export const AgePicker: FC = () => {
  const { setCurrentEvent, currentEvent } = useRequest();
  const { setTouched } = useForm<Partial<Opportunity>>();
  const [selectedOption, setSelectedOption] = useState<Options>(() =>
    optionFromAges(currentEvent?.minAge, currentEvent?.maxAge),
  );

  useEffect(() => {
    setSelectedOption(optionFromAges(currentEvent?.minAge, currentEvent?.maxAge));
  }, [currentEvent?.minAge, currentEvent?.maxAge]);

  const ageButtons = [
    {
      label: "כולם",
      name: "all",
    },
    {
      label: "18+",
      name: "18",
    },
    {
      label: "התאמה",
      name: "custom",
    },
  ];

  const handleAgeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name as Options;
    setSelectedOption(name);
    setTouched((t) => ({ ...t, minAge: true, maxAge: true }));
    if (name === "custom") return;
    setCurrentEvent((prev) => ({
      ...prev,
      minAge: name === "18" ? 18 : 6,
      maxAge: 120,
    }));
  };

  return (
    <>
      <GenericCheckbox
        buttons={ageButtons}
        handleChange={handleAgeChange}
        text="טווח גילאים"
        value={selectedOption}
        className="more-details-label"
      />
      {selectedOption === "custom" && (
        <Stack mt="1vh" direction="row" spacing={8} alignItems="center">
          <Typography
            className="more-details-label"
            sx={{ textWrap: "nowrap" }}
          >
            התאמת גילאים
          </Typography>
          <Stack gap={2} direction="row">
            <FormTextField
              containerProps={{ direction: "row", sx: { textWrap: "nowrap" } }}
              InputProps={{
                sx: { "&.field": { height: "2rem", borderRadius: "0.6rem" } },
              }}
              min={6}
              max={120}
              counter
              name="minAge"
              label="מגיל"
            />
            <FormTextField
              containerProps={{ direction: "row", sx: { textWrap: "nowrap" } }}
              InputProps={{
                sx: { "&.field": { height: "2rem", borderRadius: "0.6rem" } },
              }}
              min={6}
              max={120}
              counter
              name="maxAge"
              label="עד גיל"
            />
          </Stack>
        </Stack>
      )}
    </>
  );
};
/* eslint-enable @typescript-eslint/naming-convention -- Mui sx*/
